import React, { useState } from "react";
import { db, auth } from "./firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getApp, initializeApp, deleteApp } from "firebase/app";
import { getAuth as getAuthSecondary, createUserWithEmailAndPassword, signOut as signOutSecondary, updateProfile } from "firebase/auth";
import Navbar from "./Navbar";
import RequireAuth from "./RequireAuth";

const C = {
  bg: "#0a0a0f",
  surface: "rgba(255,255,255,0.04)", surfaceHover: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.08)", borderFocus: "rgba(10,132,255,0.5)",
  text: "#f5f5f7", secondary: "rgba(245,245,247,0.55)", tertiary: "rgba(245,245,247,0.30)",
  accent: "#0a84ff", green: "#30d158", orange: "#ff9f0a", purple: "#bf5af2", red: "#ff453a",
};

const inputStyle = {
  width: "100%", padding: "0.75rem 0.9rem",
  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.09)",
  borderRadius: 12, color: C.text,
  fontSize: "0.9rem", boxSizing: "border-box",
  outline: "none", transition: "border-color 180ms ease",
  fontFamily: "inherit", marginBottom: "1rem",
};

const labelStyle = { display: "block", marginBottom: "0.35rem", fontSize: "0.75rem", color: C.secondary, fontWeight: 500 };

function Section({ title, color = C.accent, children }) {
  return (
    <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 20, padding: "1.4rem", marginBottom: "1rem" }}>
      <p style={{ margin: "0 0 1.1rem", fontSize: "0.75rem", color, fontWeight: 600, letterSpacing: "0.3px" }}>{title}</p>
      {children}
    </div>
  );
}

function Grid2({ children }) {
  return <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 0.75rem" }}>{children}</div>;
}

function Field({ label, children }) {
  return <div><label style={labelStyle}>{label}</label>{children}</div>;
}

function Input({ value, onChange, placeholder, type = "text", disabled }) {
  return (
    <input
      style={{ ...inputStyle, opacity: disabled ? 0.4 : 1 }}
      type={type} value={value}
      onChange={onChange} placeholder={placeholder}
      disabled={disabled}
      onFocus={e => e.target.style.borderColor = C.accent + "88"}
      onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
    />
  );
}

export default function AdminLocali() {
  const [tag, setTag] = useState("");
  const [nome, setNome] = useState("");
  const [tavoli, setTavoli] = useState(0);
  const [sale, setSale] = useState([]);
  const [modalitaAsporto, setModalitaAsporto] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");
  const [emailGestore, setEmailGestore] = useState("");
  const [passwordGestore, setPasswordGestore] = useState("");
  const [messaggio, setMessaggio] = useState("");
  const [piva, setPiva] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [citta, setCitta] = useState("");
  const [provincia, setProvincia] = useState("");
  const [cap, setCap] = useState("");
  const [referente, setReferente] = useState("");
  const [telefonoReferente, setTelefonoReferente] = useState("");
  const [colorePrimario, setColorePrimario] = useState("#3E2723");
  const [coloreSecondario, setColoreSecondario] = useState("#8B4513");
  const [coloreSfondo, setColoreSfondo] = useState("#FAEBD7");
  const [coloreTesto, setColoreTesto] = useState("#3E2723");
  const [loading, setLoading] = useState(false);

  const aggiungiSala = () => {
    const l = String.fromCharCode(65 + sale.length);
    if (sale.length >= 26) { setMessaggio("⚠️ Massimo 26 sale (A-Z)"); return; }
    setSale([...sale, { lettera: l, numeroTavoli: 1 }]);
  };
  const modificaTavoliSala = (i, v) => { const s = [...sale]; s[i].numeroTavoli = v === "" ? "" : parseInt(v); setSale(s); };
  const rimuoviSala = (i) => setSale(sale.filter((_, x) => x !== i));

  const creaLocale = async () => {
    if (!tag || !nome || (!modalitaAsporto && tavoli <= 0) || !emailGestore || !passwordGestore || !piva || !ragioneSociale || !citta || !provincia || !cap || !referente || !telefonoReferente) {
      setMessaggio("⚠️ Compila tutti i campi obbligatori."); return;
    }
    setLoading(true);
    let logoUrl = "";
    if (logoFile) {
      try {
        const storage = getStorage();
        const tagNorm = tag.toLowerCase().replace(/[^a-z0-9]/gi, "");
        const sRef = ref(storage, `public/loghiLocali/${tagNorm}.png`);
        await uploadBytes(sRef, logoFile);
        logoUrl = await getDownloadURL(sRef);
      } catch { setMessaggio("❌ Errore nel caricamento del logo."); setLoading(false); return; }
    }
    try {
      const tagNorm = tag.toLowerCase().replace(/[^a-z0-9]/gi, "");
      await setDoc(doc(db, "locali", tagNorm), {
        nome, numeroTavoli: modalitaAsporto ? 0 : tavoli, modalitaAsporto: modalitaAsporto || false,
        sale: modalitaAsporto ? [] : sale, logoUrl, piva, ragioneSociale, citta, provincia, cap, referente, telefonoReferente,
        colori: { primario: colorePrimario, secondario: coloreSecondario, sfondo: coloreSfondo, testo: coloreTesto },
        creatoDa: auth.currentUser.email || "admin", creatoIl: serverTimestamp(),
      });
      const primaryApp = getApp();
      const secondaryApp = initializeApp(primaryApp.options, "SecondaryAppForUserCreation");
      const secondaryAuth = getAuthSecondary(secondaryApp);
      const userCred = await createUserWithEmailAndPassword(secondaryAuth, emailGestore, passwordGestore);
      try { await updateProfile(userCred.user, { displayName: nome || "Gestore" }); } catch {}
      await setDoc(doc(db, "utenti", userCred.user.uid), { nome: nome || "Gestore", email: emailGestore, ruolo: "gestore", localeTag: tagNorm || tag, creatoIl: serverTimestamp() });
      try { await signOutSecondary(secondaryAuth); } catch {}
      try { await deleteApp(secondaryApp); } catch {}
      setMessaggio(`✅ "${nome}" creato. Gestore: ${emailGestore}`);
      setTag(""); setNome(""); setTavoli(0); setModalitaAsporto(false); setSale([]);
      setLogoFile(null); setLogoPreview(""); setEmailGestore(""); setPasswordGestore("");
      setPiva(""); setRagioneSociale(""); setCitta(""); setProvincia(""); setCap(""); setReferente(""); setTelefonoReferente("");
    } catch (e) { setMessaggio(`❌ ${e.message}`); }
    setLoading(false);
  };

  const isOk = messaggio.startsWith("✅");

  return (
    <RequireAuth>
      <Navbar />
      <div style={{ minHeight: "100vh", background: C.bg, fontFamily: "-apple-system, 'SF Pro Display', 'Helvetica Neue', sans-serif", color: C.text }}>
        <div className="page-with-navbar" style={{ maxWidth: 680, margin: "0 auto" }}>

          {/* Header */}
          <div style={{ marginBottom: "2rem" }}>
            <p style={{ margin: "0 0 0.25rem", fontSize: "0.75rem", color: C.secondary, fontWeight: 500 }}>Amministrazione</p>
            <h1 style={{ margin: 0, fontSize: "clamp(1.4rem, 3vw, 1.9rem)", fontWeight: 700, letterSpacing: "-0.5px" }}>Crea nuovo locale</h1>
          </div>

          {/* ── Identità ── */}
          <Section title="Identità del locale" color={C.accent}>
            <Grid2>
              <Field label="Tag univoco *">
                <Input value={tag} onChange={e => setTag(e.target.value.trim())} placeholder="es. capriccio" />
              </Field>
              <Field label="Nome del locale *">
                <Input value={nome} onChange={e => setNome(e.target.value)} placeholder="es. Il Capriccio" />
              </Field>
            </Grid2>
          </Section>

          {/* ── Dati fiscali ── */}
          <Section title="Dati fiscali" color={C.purple}>
            <Grid2>
              <Field label="Partita IVA *"><Input value={piva} onChange={e => setPiva(e.target.value)} placeholder="12345678901" /></Field>
              <Field label="Ragione Sociale *"><Input value={ragioneSociale} onChange={e => setRagioneSociale(e.target.value)} placeholder="Srl / Snc..." /></Field>
              <Field label="Città *"><Input value={citta} onChange={e => setCitta(e.target.value)} placeholder="es. Milano" /></Field>
              <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "0 0.5rem" }}>
                <Field label="Provincia *"><Input value={provincia} onChange={e => setProvincia(e.target.value)} placeholder="MI" /></Field>
                <Field label="CAP *"><Input value={cap} onChange={e => setCap(e.target.value)} placeholder="20100" /></Field>
              </div>
              <Field label="Referente *"><Input value={referente} onChange={e => setReferente(e.target.value)} placeholder="Nome Cognome" /></Field>
              <Field label="Telefono *"><Input value={telefonoReferente} onChange={e => setTelefonoReferente(e.target.value)} placeholder="333 123 4567" /></Field>
            </Grid2>
          </Section>

          {/* ── Tavoli ── */}
          <Section title="Configurazione" color={C.green}>
            <div style={{ display: "flex", gap: "0.75rem", alignItems: "flex-end", marginBottom: "1rem" }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Numero tavoli principali</label>
                <input style={{ ...inputStyle, opacity: modalitaAsporto ? 0.35 : 1, marginBottom: 0 }}
                  type="number" value={tavoli} onChange={e => setTavoli(parseInt(e.target.value))} min={1} disabled={modalitaAsporto}
                  onFocus={e => e.target.style.borderColor = C.accent + "88"}
                  onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.09)"}
                />
              </div>
              <button type="button" onClick={() => { setModalitaAsporto(!modalitaAsporto); if (!modalitaAsporto) { setTavoli(0); setSale([]); } }}
                style={{ padding: "0.75rem 1.1rem", background: modalitaAsporto ? C.orange + "20" : C.surface, border: `1px solid ${modalitaAsporto ? C.orange + "55" : C.border}`, borderRadius: 12, color: modalitaAsporto ? C.orange : C.secondary, fontSize: "0.82rem", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", transition: "all 180ms ease", fontFamily: "inherit" }}>
                {modalitaAsporto ? "Asporto attivo" : "Modalità tavoli"}
              </button>
            </div>
            {modalitaAsporto && (
              <div style={{ padding: "0.65rem 0.9rem", background: C.orange + "12", border: `1px solid ${C.orange}30`, borderRadius: 10, fontSize: "0.78rem", color: C.orange, marginBottom: "1rem" }}>
                Verrà generato un QR unico per /menu-asporto
              </div>
            )}
            {!modalitaAsporto && (
              <div style={{ padding: "0.9rem", background: "rgba(48,209,88,0.05)", border: "1px solid rgba(48,209,88,0.15)", borderRadius: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: sale.length ? "0.75rem" : 0 }}>
                  <span style={{ fontSize: "0.75rem", color: C.secondary, fontWeight: 500 }}>Sale aggiuntive</span>
                  <button type="button" onClick={aggiungiSala} style={{ padding: "0.35rem 0.75rem", background: C.green + "18", border: `1px solid ${C.green}33`, borderRadius: 8, color: C.green, fontSize: "0.73rem", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                    + Aggiungi sala
                  </button>
                </div>
                {sale.map((sala, idx) => (
                  <div key={idx} style={{ display: "flex", alignItems: "center", gap: "0.5rem", padding: "0.5rem 0.65rem", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 10, marginBottom: "0.4rem" }}>
                    <span style={{ fontWeight: 600, color: C.green, fontSize: "0.78rem", minWidth: 48 }}>Sala {sala.lettera}</span>
                    <input type="number" value={sala.numeroTavoli} min={1} onChange={e => modificaTavoliSala(idx, e.target.value)}
                      style={{ flex: 1, padding: "0.35rem 0.5rem", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 7, color: C.text, fontSize: "0.8rem", outline: "none" }} />
                    <span style={{ fontSize: "0.7rem", color: C.tertiary }}>tavoli</span>
                    <button type="button" onClick={() => rimuoviSala(idx)} style={{ background: C.red + "18", border: `1px solid ${C.red}30`, borderRadius: 7, color: C.red, padding: "0.3rem 0.5rem", cursor: "pointer", fontSize: "0.72rem", fontFamily: "inherit" }}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </Section>

          {/* ── Logo ── */}
          <Section title="Logo" color={C.orange}>
            <label style={labelStyle}>Immagine PNG / JPG</label>
            <input type="file" accept="image/*" onChange={e => { const f = e.target.files[0]; setLogoFile(f); if (f) { const r = new FileReader(); r.onloadend = () => setLogoPreview(r.result); r.readAsDataURL(f); } }}
              style={{ width: "100%", padding: "0.65rem", background: "rgba(255,255,255,0.04)", border: "1px dashed rgba(255,255,255,0.12)", borderRadius: 12, color: C.secondary, fontSize: "0.8rem", cursor: "pointer", boxSizing: "border-box" }}
            />
            {logoPreview && (
              <div style={{ display: "flex", alignItems: "center", gap: "0.85rem", marginTop: "0.85rem", padding: "0.75rem", background: "rgba(255,255,255,0.04)", borderRadius: 12 }}>
                <img src={logoPreview} alt="Preview" style={{ height: 56, width: 56, objectFit: "contain", borderRadius: 10, background: "rgba(255,255,255,0.08)" }} />
                <span style={{ fontSize: "0.75rem", color: C.secondary }}>Anteprima logo</span>
              </div>
            )}
          </Section>

          {/* ── Colori ── */}
          <Section title="Colori menu asporto" color={C.purple}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 0.75rem" }}>
              {[
                { label: "Primario",   hint: "Header",    val: colorePrimario,   set: setColorePrimario },
                { label: "Secondario", hint: "Accenti",   val: coloreSecondario, set: setColoreSecondario },
                { label: "Sfondo",     hint: "Sfondo",    val: coloreSfondo,     set: setColoreSfondo },
                { label: "Testo",      hint: "Testo",     val: coloreTesto,      set: setColoreTesto },
              ].map(({ label, hint, val, set }) => (
                <div key={label}>
                  <label style={labelStyle}>{label} <span style={{ color: C.tertiary }}>— {hint}</span></label>
                  <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", marginBottom: "1rem" }}>
                    <input type="color" value={val} onChange={e => set(e.target.value)} style={{ width: 40, height: 36, border: "1px solid rgba(255,255,255,0.12)", borderRadius: 8, cursor: "pointer", background: "transparent", padding: 0, flexShrink: 0 }} />
                    <input type="text" value={val} onChange={e => set(e.target.value)} style={{ ...inputStyle, marginBottom: 0, flex: 1, fontFamily: "monospace", fontSize: "0.8rem" }} />
                  </div>
                </div>
              ))}
            </div>
            {/* Preview */}
            <div style={{ padding: "1rem", backgroundColor: coloreSfondo, borderRadius: 12, border: `1.5px solid ${colorePrimario}` }}>
              <div style={{ backgroundColor: colorePrimario, color: "#fff", padding: "0.55rem 0.8rem", borderRadius: 8, fontWeight: 600, marginBottom: "0.5rem", fontSize: "0.82rem" }}>Header anteprima</div>
              <p style={{ margin: "0.4rem 0", fontSize: "0.78rem", color: coloreTesto }}>Testo di esempio su sfondo personalizzato</p>
              <button style={{ backgroundColor: coloreSecondario, color: "#fff", border: "none", padding: "0.4rem 0.8rem", borderRadius: 7, fontSize: "0.75rem", fontWeight: 600, cursor: "pointer" }}>Bottone</button>
            </div>
          </Section>

          {/* ── Account gestore ── */}
          <Section title="Account gestore" color={C.green}>
            <Grid2>
              <Field label="Email gestore *"><Input type="email" value={emailGestore} onChange={e => setEmailGestore(e.target.value)} placeholder="gestore@esempio.it" /></Field>
              <Field label="Password iniziale *"><Input type="password" value={passwordGestore} onChange={e => setPasswordGestore(e.target.value)} placeholder="min. 6 caratteri" /></Field>
            </Grid2>
            <p style={{ margin: "-0.5rem 0 0", fontSize: "0.7rem", color: C.tertiary }}>Consiglia al gestore di cambiare la password al primo accesso.</p>
          </Section>

          {/* ── Submit ── */}
          <button onClick={creaLocale} disabled={loading}
            style={{ width: "100%", padding: "0.95rem", background: loading ? C.accent + "60" : C.accent, border: "none", borderRadius: 14, color: "#fff", fontSize: "0.95rem", fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", transition: "background 180ms ease, transform 120ms ease", fontFamily: "inherit" }}
            onMouseEnter={e => { if (!loading) e.currentTarget.style.background = "#007AEB"; }}
            onMouseLeave={e => { if (!loading) e.currentTarget.style.background = C.accent; }}
          >
            {loading ? "Creazione in corso…" : "Crea locale"}
          </button>
        </div>
      </div>

      {/* Messaggio overlay */}
      {messaggio && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "1.5rem", backdropFilter: "blur(8px)" }}>
          <div style={{ position: "relative", background: "#1c1c1e", border: `1px solid ${isOk ? C.green + "44" : C.red + "44"}`, borderRadius: 22, padding: "2rem 2.25rem", maxWidth: 380, width: "100%", textAlign: "center", color: C.text, fontSize: "0.9rem", fontWeight: 500, lineHeight: 1.6, boxShadow: "0 24px 64px rgba(0,0,0,0.6)" }}>
            <button onClick={() => setMessaggio("")} style={{ position: "absolute", top: "0.85rem", right: "0.85rem", background: "none", border: "none", color: C.tertiary, fontSize: "1.3rem", cursor: "pointer", lineHeight: 1 }}>×</button>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>{isOk ? "✓" : "✕"}</div>
            {messaggio.replace("✅ ", "").replace("❌ ", "").replace("⚠️ ", "")}
          </div>
        </div>
      )}
    </RequireAuth>
  );
}
